import { Button, TextField } from '@mui/material'
import { makeStyles } from '@mui/styles'
import {
  ImageCard,
  ImageCardActions,
  ImageCardContent,
} from 'components/ImageCard/ImageCard'
import React, { ChangeEvent, useState } from 'react'
import { Images } from 'theme/Images'
import { theme } from 'theme/theme'
import { useIntl } from 'react-intl'

import messages from './ChangePassword.messages'
import { config } from 'config/config'

const useClasses = makeStyles({
  inputField1: {
    marginTop: theme.spacing(5),
    minHeight: 70,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      width: '100%',
    },
  },
  inputField: {
    marginBottom: theme.spacing(2),
    minHeight: 70,
  },
})

interface ChangePasswordProps {
  onSend: (props: { oldPassword: string; newPassword: string }) => any
}

export const ChangePassword: React.FC<ChangePasswordProps> = props => {
  const intl = useIntl()
  const requiredError = intl.formatMessage(messages.passwordRequired)
  const equalError = intl.formatMessage(messages.passwordEqual)
  const newRequiredError = intl.formatMessage(messages.newPasswordRequired)
  const matchError = intl.formatMessage(messages.passwordDontMatch)
  const currentPassword = intl.formatMessage(messages.currentPassword)
  const newPassword = intl.formatMessage(messages.newPassword)
  const newPasswordRepeat = intl.formatMessage(messages.newPasswordRepeat)
  const changePasswordButton = intl.formatMessage(messages.changePasswordButton)
  const newToShortError = intl.formatMessage(messages.newToShortError)

  const { onSend } = props
  const classes = useClasses()

  const [oldPassword, setOldPassword] = useState('')
  const [errorOldPassword, setErrorOldPassword] = useState(false)
  const [errorOldPasswordMessage, setErrorOldPasswordMessage] = useState('')

  const [newPassword0, setNewPassword0] = useState('')
  const [errorNewPassword0, setErrorNewPassword0] = useState(false)
  const [errorNewPasswordMessage0, setErrorNewPasswordMessage0] = useState('')

  const [newPassword1, setNewPassword1] = useState('')
  const [errorNewPassword1, setErrorNewPassword1] = useState(false)
  const [errorNewPasswordMessage1, setErrorNewPasswordMessage1] = useState('')

  const PASSWORD_MIN_LEN = config().passwordMinLen

  //
  // Old password
  //
  function resetOldPasswordValidation() {
    setErrorOldPassword(false)
    setErrorOldPasswordMessage('')
  }

  function validateOldPassword() {
    resetOldPasswordValidation()

    if (oldPassword === '') {
      setErrorOldPassword(true)
      setErrorOldPasswordMessage(requiredError)
    }
  }

  //
  // NewPassword0
  //
  function resetNewPassword0Validation() {
    setErrorNewPassword0(false)
    setErrorNewPasswordMessage0('')
  }

  function validateNewPassword0() {
    resetNewPassword0Validation()

    if (newPassword0 === oldPassword) {
      setErrorNewPassword0(true)
      setErrorNewPasswordMessage0(equalError)
    }

    if (newPassword0 === '') {
      setErrorNewPassword0(true)
      setErrorNewPasswordMessage0(newRequiredError)
    }
    if (newPassword0.length < PASSWORD_MIN_LEN) {
      setErrorNewPassword0(true)
      setErrorNewPasswordMessage0(newToShortError)
    }
  }

  //
  // NewPassword1
  //
  function resetNewPassword1Validation() {
    setErrorNewPassword1(false)
    setErrorNewPasswordMessage1('')
  }

  function validateNewPassword1() {
    resetNewPassword1Validation()

    if (newPassword0 !== newPassword1) {
      setErrorNewPassword1(true)
      setErrorNewPasswordMessage1(matchError)
    }

    if (newPassword0.length < PASSWORD_MIN_LEN) {
      setErrorNewPassword0(true)
      setErrorNewPasswordMessage0(newToShortError)
    }
  }

  function validate() {
    validateOldPassword()
    validateNewPassword0()
    validateNewPassword1()

    const errorNewPasswordMatch = newPassword0 !== newPassword1

    return !errorNewPasswordMatch && !errorOldPassword && !errorNewPassword0
  }

  function handleSetOldPassword(e: ChangeEvent<HTMLInputElement>) {
    resetOldPasswordValidation()
    setOldPassword(e.target.value)
  }

  function handleSetNewPassword0(e: ChangeEvent<HTMLInputElement>) {
    resetNewPassword0Validation()
    setNewPassword0(e.target.value)
  }

  function handleSetNewPassword1(e: ChangeEvent<HTMLInputElement>) {
    resetNewPassword1Validation()
    setNewPassword1(e.target.value)
  }

  function sendChangePasswordRequest() {
    const valid = validate()
    if (valid) {
      onSend({ oldPassword, newPassword: newPassword0 })
    }
  }

  return (
    <ImageCard imgUrl={Images.securityOn}>
      <ImageCardContent>
        <TextField
          value={oldPassword}
          autoFocus
          label={currentPassword}
          onChange={handleSetOldPassword}
          className={classes.inputField1}
          onBlur={validateOldPassword}
          error={errorOldPassword}
          helperText={errorOldPasswordMessage}
          type='password'
          placeholder={currentPassword}
        />
        <TextField
          value={newPassword0}
          label={newPassword}
          onChange={handleSetNewPassword0}
          className={classes.inputField}
          onBlur={validateNewPassword0}
          error={errorNewPassword0}
          helperText={errorNewPasswordMessage0}
          type='password'
          placeholder={newPassword}
        />
        <TextField
          value={newPassword1}
          label={newPasswordRepeat}
          onChange={handleSetNewPassword1}
          onBlur={validateNewPassword1}
          className={classes.inputField}
          error={errorNewPassword1}
          helperText={errorNewPasswordMessage1}
          type='password'
          placeholder={newPasswordRepeat}
        />
      </ImageCardContent>
      <ImageCardActions>
        <Button
          color='secondary'
          variant='contained'
          onClick={sendChangePasswordRequest}
        >
          {changePasswordButton}
        </Button>
      </ImageCardActions>
    </ImageCard>
  )
}

export default ChangePassword
